import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import {MatDialog} from "@angular/material/dialog";
import { UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import {InboundLocationForm, LocationNode, OutboundLocationForm} from "./location-node";
import { MatButtonToggleGroup, MatButtonToggle } from "@angular/material/button-toggle";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { NgTemplateOutlet } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { SelectMediaToggleComponent } from '../../../../select-media-toggle/select-media-toggle.component';

const NODE_TYPE = 'location';

@Component({
    selector: 'app-location-node',
    templateUrl: './location-node.component.html',
    styleUrls: ['./location-node.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, MatButtonToggleGroup, MatButtonToggle, NgTemplateOutlet, CMSComponent, NextSelectorComponent, ClickatellFormValidationComponent, ActiveFormDirective, SelectMediaToggleComponent]
})
export class LocationNodeComponent extends NodeBuilder implements OnInit {

  locationForm: UntypedFormGroup = undefined;
  newStep = undefined;
  selectedHeaderType: "text" | "media" = "text"
  stepUniqueID: string = '';


  constructor(public dialog: MatDialog) {
    super(NODE_TYPE);
  }

  ngOnInit(): void {

  }

  set buildForm(stepData: any) {
    this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
    this.locationForm = LocationNode.toForm(stepData, this.canEdit);

    if (this.locationForm.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep()
      this.locationForm.get('next').setValue(this.newStep);
    }

    this.getHeaderType(this.locationForm.getRawValue())

  }

  get getStepData(): {} {
    const locationNode = new LocationNode();
    const rawValue = this.locationForm.getRawValue();
    locationNode.setMenu(rawValue);
    const nodeData = locationNode.nodeData;
    nodeData['next'] = rawValue.next;
    return nodeData;
  }

  get isNodeValid(): boolean {
    this.locationForm.markAllAsTouched();
    return this.locationForm.valid;
  }

  public directionChange(event: MatButtonToggleGroup): void {
    // Note: previousNextValue is required as locationNode.getForm resets the session variables.
    const previousNextValue = this.locationForm.get('next').value;
    this.locationForm = LocationNode.getForm(event.value, {}, this.canEdit);
    this.locationForm.get('next').setValue(previousNextValue);

    if (this.locationForm.get('next').value === newStepValue) {
      this.locationForm.get('next').setValue(this.newStep);
    }
  }

  public headerChange(event: MatButtonToggleGroup): void {
    this.clearToggledValuesOnNewSelection(event.value);
    this.selectedHeaderType = event.value;
  }

  private getHeaderType(rawData: InboundLocationForm | OutboundLocationForm) {
    if (rawData?.direction === "inbound") {
      if (rawData.header !== undefined && rawData.header.length > 0) {
        this.selectedHeaderType = "text"
      } else if (rawData.imageRef !== undefined && rawData.imageRef.length > 0) {
        this.selectedHeaderType = "media"
      }
    }
  }

  private clearToggledValuesOnNewSelection(selectedHeaderType) {
    switch(selectedHeaderType) {
      case 'media':
        this.locationForm.get('header').setValue('');
        break;
      case 'text':
        this.locationForm.get('imageRef').setValue('');
        break;
    }
  }
}
